.public-layout-header{width:100%;background-color:#1c0c5b;padding:20px 30px}.logo-wrapper img{height:65px;width:65px}.header-title{margin-left:20px;color:#fff;margin-bottom:0}
/*# sourceMappingURL=public-layout-header.component-ZGYTR4W5.css.map */
